import { render, staticRenderFns } from "./Notifications_TwitterConfiguration.vue?vue&type=template&id=726bd967&scoped=true&"
import script from "./Notifications_TwitterConfiguration.vue?vue&type=script&lang=js&"
export * from "./Notifications_TwitterConfiguration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "726bd967",
  null
  
)

export default component.exports